/** Mirrors crm Industry / Region (ADR-108). Region is derived server-side from
 *  the company's country — read-only here. */
export const INDUSTRIES = [
  { value: 'saas', label: 'SaaS' },
  { value: 'ecommerce', label: 'E-commerce' },
  { value: 'fintech', label: 'Fintech' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'edtech', label: 'EdTech' },
  { value: 'real_estate', label: 'Real estate' },
  { value: 'logistics', label: 'Logistics' },
  { value: 'marketing', label: 'Marketing / Agency' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'media', label: 'Media' },
  { value: 'other', label: 'Other' },
] as const;

export type Industry = (typeof INDUSTRIES)[number]['value'];

export const REGIONS = [
  { value: 'europe', label: 'Europe' },
  { value: 'north_america', label: 'North America' },
  { value: 'latam', label: 'Latin America' },
  { value: 'mena', label: 'Middle East & North Africa' },
  { value: 'apac', label: 'Asia-Pacific' },
  { value: 'africa', label: 'Sub-Saharan Africa' },
] as const;

export type Region = (typeof REGIONS)[number]['value'];

export const industryLabel = (v: string): string =>
  INDUSTRIES.find((x) => x.value === v)?.label ?? v;

export const regionLabel = (v: string): string =>
  REGIONS.find((x) => x.value === v)?.label ?? v;

/** Bounds mirrored from the backend (COMPANY_TECHNOLOGIES_MAX / _MAX_LENGTH). */
export const MAX_TECHNOLOGIES = 20;
export const MAX_TECHNOLOGY_LENGTH = 64;
